module.exports = __webpack_public_path__ + "img/warning.0eaf3c00.png";